import { render, staticRenderFns } from "./scopecenter6.vue?vue&type=template&id=77adcd18&scoped=true"
import script from "./scopecenter6.vue?vue&type=script&lang=js"
export * from "./scopecenter6.vue?vue&type=script&lang=js"
import style0 from "./scopecenter6.vue?vue&type=style&index=0&id=77adcd18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77adcd18",
  null
  
)

export default component.exports